<input type="text" class="outline-none flex-1 bg-transparent tranistion-colors duration-300"
  placeholder="{{searchBoxPlaceholder}}" role="combobox" aria-expanded="false" aria-controls="options" #addresstext
  [attr.disabled]="disabled ? '' : null">